import type { EstadoLead } from '@app/shared';

import { useI18n } from '../../../i18n/I18nProvider';
import { cn } from '../../../lib/cn';

// Chips de estado y etapa. Colores desde la paleta (tokens.css), nunca hex.

const TONO_ESTADO: Record<EstadoLead, string> = {
  NUEVO: 'bg-marca-primario text-white',
  ACTIVO: 'bg-info/15 text-info',
  ESPERANDO_RESPUESTA: 'bg-warning/20 text-text-strong',
  RECONTACTO_1: 'bg-marca-naranja/20 text-text-strong',
  RECONTACTO_2: 'bg-marca-naranja/30 text-text-strong',
  CERRADO_GANADO: 'bg-success/15 text-success',
  CERRADO_NO_INTERESADO: 'bg-surface-muted text-text-subtle',
  CERRADO_SIN_RESPUESTA: 'bg-surface-muted text-text-subtle',
  DERIVADO_SALUD: 'bg-danger/15 text-danger',
  HISTORICO: 'border border-border-strong bg-transparent text-text-faint',
  BLOQUEADO: 'bg-danger/20 text-danger',
};

export function ChipEstado({ estado, className }: { estado: EstadoLead; className?: string }): JSX.Element {
  const es = useI18n();
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium leading-4',
        TONO_ESTADO[estado],
        className,
      )}
    >
      {es.bandeja.estados[estado]}
    </span>
  );
}

export function ChipEtapa({ etapa, className }: { etapa: number; className?: string }): JSX.Element {
  const es = useI18n();
  const nombre = es.bandeja.etapas[etapa as 1 | 2 | 3 | 4 | 5];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-border-strong px-2 py-0.5 text-[11px] font-medium leading-4 text-text-subtle',
        className,
      )}
      title={`${es.bandeja.etapa} ${String(etapa)}`}
    >
      <span className="font-semibold text-text-strong">{etapa}</span>
      {nombre}
    </span>
  );
}

// El número de Metamorfosis por el que pasa un chat (Ciclo 1b). Color sólido con
// texto blanco: legible en claro y en oscuro sin depender del fondo.
export function ChipInstancia({
  instancia,
  preferida = false,
  className,
}: {
  instancia: { etiqueta: string; color: string; nombre: string };
  preferida?: boolean;
  className?: string;
}): JSX.Element {
  const es = useI18n();
  return (
    <span
      title={preferida ? `${instancia.nombre} · ${es.bandeja.numeros.preferido}` : instancia.nombre}
      style={{ backgroundColor: `hsl(${instancia.color})` }}
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 text-[11px] font-semibold leading-4 text-white',
        preferida && 'ring-2 ring-white/70 ring-offset-1 ring-offset-surface',
        className,
      )}
    >
      {instancia.etiqueta}
      {preferida && (
        <span aria-hidden className="text-[9px]">
          ★
        </span>
      )}
    </span>
  );
}
